import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ApiClient } from '@core/http/api-client';
import { InitiateTilesUpload, OrthophotoItem, SignedTile } from './orthophoto.model';

@Injectable({ providedIn: 'root' })
export class OrthophotoApi {
	constructor(
		private readonly api: ApiClient,
		private readonly http: HttpClient,
	) {}

	getAll(): Observable<OrthophotoItem[]> {
		return this.api.get<OrthophotoItem[]>('/orthophoto/getAll');
	}

	getByFarmId(farmId: string): Observable<OrthophotoItem | null> {
		return this.api.get<OrthophotoItem | null>(`/orthophoto/getByFarmId/${farmId}`);
	}

	initiateTilesUpload(farmId: string): Observable<InitiateTilesUpload> {
		return this.api.post<InitiateTilesUpload>('/orthophoto/initiateTilesUpload', { farmId });
	}

	signTiles(
		farmId: string,
		uploadId: string,
		tilePaths: string[],
	): Observable<{ bucketName: string; tiles: SignedTile[] }> {
		return this.api.post<{ bucketName: string; tiles: SignedTile[] }>('/orthophoto/signTiles', {
			farmId,
			uploadId,
			tilePaths,
		});
	}

	uploadTile(presignedUrl: string, file: File): Observable<unknown> {
		return this.http.put(presignedUrl, file, { responseType: 'text' });
	}

	finalizeTilesUpload(farmId: string, uploadId: string, tileCount: number): Observable<OrthophotoItem> {
		return this.api.post<OrthophotoItem>('/orthophoto/finalizeTilesUpload', {
			farmId,
			uploadId,
			tileCount,
		});
	}

	delete(farmId: string): Observable<{ message: string }> {
		return this.api.delete<{ message: string }>(`/orthophoto/delete/${farmId}`);
	}
}
